import {
  ComponentFactoryResolver, ComponentRef,
  Directive, Input,
  OnChanges, OnDestroy,
  SimpleChanges, ViewContainerRef,
} from '@angular/core';
import { AbstractControl, ControlContainer, FormGroup } from '@angular/forms';
import { MessagesComponent } from '../components/messages/messages.component';
import { MfpcInputsInterface } from 'base-form';
import { SubscriptionLike } from 'rxjs';
import { ValidatorMessages } from '../constants/validator-messages.dictionary';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[formField]',
})
export class FormFieldDirective implements OnChanges, OnDestroy {
  @Input() form: FormGroup;

  @Input() item:  MfpcInputsInterface;

  private messagesRef: ComponentRef<MessagesComponent>;

  private statusSub: SubscriptionLike;

  constructor(
    private controlContainer: ControlContainer,
    private cfr: ComponentFactoryResolver,
    private vcr: ViewContainerRef
  ) {
    const messagesFactory = this.cfr.resolveComponentFactory(MessagesComponent);
    this.messagesRef = this.vcr.createComponent(messagesFactory);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      changes.item?.currentValue &&
      changes.form?.currentValue &&
      this.form.get(this.item.formControlName)
    ) {
      const control = this.form.get(this.item.formControlName);
      this.handleStatus(control);
      this.messagesRef.instance.controlName = this.item.formControlName;
      this.messagesRef.instance.hint = this.item.hintMessage;
    }
  }

  ngOnDestroy(): void {
    if (this.statusSub) {
      this.statusSub.unsubscribe();
    }
  }

  private handleStatus(control: AbstractControl): void {
    if (!this.statusSub) {
      this.statusSub = control.statusChanges.subscribe(status => {
        if (status === 'INVALID' && control.errors) {
          this.messagesRef.instance.errors = [
            ...Object.keys(control.errors)
              .map((error) => {
                const message = ValidatorMessages[error];
                return (
                  message ??
                  (typeof control.errors[error] === 'string'
                    ? control.errors[error]
                    : null)
                );
              })
              .filter((item) => item),
          ];
        } else {
          this.messagesRef.instance.errors = [];
        }
      })
    }
  }
}
